export const NEW_DASHBOARD_SEARCH_EXPERIMENT = 'new_dashboard_search';

export const isNewDashboardSearchEnabled = () => true;
